import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import { RotateDevicePrompt, useIsLandscape } from '@appcharge/shared-ui';

import { BootResponse } from '../../constants/apiResponses.types';

interface IRotateDevicePromptWrapperProps {
  publisherMetaData?: BootResponse;
}

export const RotateDevicePromptWrapper: React.FC<
  IRotateDevicePromptWrapperProps
> = ({ publisherMetaData }) => {
  const { t } = useTranslation();
  const isLandscape = useIsLandscape();

  const showRotatePrompt =
    !!publisherMetaData?.storeTheme?.general?.showRotatePrompt;

  if (!showRotatePrompt || !isMobile || !isLandscape) {
    return null;
  }

  return <RotateDevicePrompt t={t} />;
};
